module.exports = __webpack_public_path__ + "img/person-dress.9bc0a8bf.svg";